/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the KeyInfoDto interface.
 */
export function instanceOfKeyInfoDto(value) {
    const v = value;
    if ((!('camelot' in v) && !('Camelot' in v)) || (v['camelot'] === undefined && v['Camelot'] === undefined))
        return false;
    if ((!('spotifyID' in v) && !('SpotifyID' in v)) || (v['spotifyID'] === undefined && v['SpotifyID'] === undefined))
        return false;
    if ((!('spotifyMode' in v) && !('SpotifyMode' in v)) || (v['spotifyMode'] === undefined && v['SpotifyMode'] === undefined))
        return false;
    if ((!('standard' in v) && !('Standard' in v)) || (v['standard'] === undefined && v['Standard'] === undefined))
        return false;
    if ((!('relative' in v) && !('Relative' in v)) || (v['relative'] === undefined && v['Relative'] === undefined))
        return false;
    if ((!('perfectMatch' in v) && !('PerfectMatch' in v)) || (v['perfectMatch'] === undefined && v['PerfectMatch'] === undefined))
        return false;
    if ((!('energyBoost' in v) && !('EnergyBoost' in v)) || (v['energyBoost'] === undefined && v['EnergyBoost'] === undefined))
        return false;
    if ((!('energyDrop' in v) && !('EnergyDrop' in v)) || (v['energyDrop'] === undefined && v['EnergyDrop'] === undefined))
        return false;
    if ((!('moodChange' in v) && !('MoodChange' in v)) || (v['moodChange'] === undefined && v['MoodChange'] === undefined))
        return false;
    if ((!('compatible' in v) && !('Compatible' in v)) || (v['compatible'] === undefined && v['Compatible'] === undefined))
        return false;
    return true;
}
export function KeyInfoDtoFromJSON(json) {
    return KeyInfoDtoFromJSONTyped(json, false);
}
export function KeyInfoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'camelot': json['Camelot'],
        'spotifyID': json['SpotifyID'],
        'spotifyMode': json['SpotifyMode'],
        'standard': json['Standard'],
        'relative': json['Relative'],
        'perfectMatch': json['PerfectMatch'],
        'energyBoost': json['EnergyBoost'],
        'energyDrop': json['EnergyDrop'],
        'moodChange': json['MoodChange'],
        'compatible': json['Compatible'],
    };
}
export function KeyInfoDtoToJSON(json) {
    return KeyInfoDtoToJSONTyped(json, false);
}
export function KeyInfoDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Camelot': value['camelot'],
        'SpotifyID': value['spotifyID'],
        'SpotifyMode': value['spotifyMode'],
        'Standard': value['standard'],
        'Relative': value['relative'],
        'PerfectMatch': value['perfectMatch'],
        'EnergyBoost': value['energyBoost'],
        'EnergyDrop': value['energyDrop'],
        'MoodChange': value['moodChange'],
        'Compatible': value['compatible'],
    };
}
